// @flow
import * as React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import type { AppStateType } from '@reducers/appstate'
import LinkApple from '@components/auth/SocialAuth/LinkAccounts/LinkApple'
import LinkGoogle from '@components/auth/SocialAuth/LinkAccounts/LinkGoogle'
import LinkFacebook from '@components/auth/SocialAuth/LinkAccounts/LinkFacebook'
import { colors, ErrorMessage, ErrorMessageContainer, SocialButtons } from '@components/shared'
import { PROVIDERS } from '../../flowTypes'
import { LinkWithUtms } from '../../actions/navigationActions'
import type { ProvidersType } from '../../flowTypes'
import { config } from 'react-awesome-styled-grid'
import { resetEmailUpdate } from '../../actions/userActions'

export type PropsType = {
  email: string,
  providers: ProvidersType[],
  featureAppleAuth: boolean,
  featureGoogleAuth: boolean,
  featureFacebookAuth: boolean,
  linkAccountErrorText?: string,
  onlyShowCurrentProviders?: boolean
}

export type DispatchPropsType = {
  clearErrorMessages: () => void
}

function ManageSocial (props: PropsType & DispatchPropsType): React.Node {
  const [disconnectError, setDisconnectError] = React.useState<?string>(null)
  const [connectError, setConnectError] = React.useState<?string>(null)
  React.useEffect((): void => {
    if ((props.linkAccountErrorText || '').includes('disconnect')) {
      setDisconnectError(props.linkAccountErrorText)
      setConnectError(null)
    } else {
      setConnectError(props.linkAccountErrorText)
      setDisconnectError(null)
    }
  }, [props.linkAccountErrorText])
  React.useEffect((): any => {
    return (): void => {
      props.clearErrorMessages()
    }
  }, [])
  const currentUserProviders = [
    (props.featureAppleAuth && PROVIDERS.apple),
    (props.featureGoogleAuth && PROVIDERS.google),
    (props.featureFacebookAuth && PROVIDERS.facebook),
    PROVIDERS.email
  ].filter((provider: ProvidersType | boolean): boolean => props.providers.includes(provider))

  const currentlySignedInWith = (<>
    {currentUserProviders.map((provider: any, index: number): string => {
      let currentProvider = ''
      switch (provider) {
        case PROVIDERS.apple:
          currentProvider = 'Apple'
          break
        case PROVIDERS.google:
          currentProvider = 'Google'
          break
        case PROVIDERS.facebook:
          currentProvider = 'Facebook'
          break
        case PROVIDERS.email:
          currentProvider = props.email || ''
          break
        default:
          break
      }
      if (index === (currentUserProviders.length - 1)) {
        if (currentUserProviders.length === 1) {
          return `${currentProvider}`
        } else if (currentUserProviders.length === 2) {
          return ` and ${currentProvider}`
        } else {
          return `, and ${currentProvider}`
        }
      } else if (index < (currentUserProviders.length - 1) && index !== 0) {
        return `, ${currentProvider}`
      } else {
        return currentProvider
      }
    })}
  </>)
  if (props.onlyShowCurrentProviders) {
    return currentlySignedInWith
  }
  return (
    <AccountTopSection>
      {disconnectError && <ErrorMessageContainer minHeight='12px' styles={{ marginBottom: '6px' }}>
        <ErrorMessage showError={disconnectError}>{disconnectError}</ErrorMessage>
      </ErrorMessageContainer>}

      {props.providers.includes(PROVIDERS.apple) && props.featureAppleAuth && (
        <LinkApple />
      )}
      {props.providers.includes(PROVIDERS.google) && props.featureGoogleAuth && (
        <LinkGoogle />
      )}
      {props.providers.includes(PROVIDERS.facebook) && props.featureFacebookAuth && (
        <LinkFacebook />
      )}
      {connectError && <ErrorMessageContainer minHeight='12px'>
        <ErrorMessage showError={connectError} >{connectError}</ErrorMessage>
      </ErrorMessageContainer>}
      {!props.providers.includes(PROVIDERS.email) && (
        <LinkWithUtms pathname={'/account/add-email'}>
          <SocialButtons
            isOutlineStyle={true}
          >
            Enable email sign in
          </SocialButtons>
        </LinkWithUtms>
      )}
      {!props.providers.includes(PROVIDERS.apple) && props.featureAppleAuth && (
        <LinkApple />
      )}
      {!props.providers.includes(PROVIDERS.google) && props.featureGoogleAuth && (
        <LinkGoogle />
      )}
      {!props.providers.includes(PROVIDERS.facebook) && props.featureFacebookAuth && (
        <LinkFacebook />
      )}
    </AccountTopSection>
  )
}

const mapStateToProps = (state: AppStateType): any => {
  return ({
    email: state.user.email,
    providers: [...(state.user.providers || [])],
    featureAppleAuth: state.featureAppleAuth,
    featureGoogleAuth: state.featureGoogleAuth,
    featureFacebookAuth: state.featureFacebookAuth,
    linkAccountErrorText: state.linkAccountErrorText
  }: PropsType)
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return ({
    clearErrorMessages: (): void => dispatch(resetEmailUpdate())
  }: DispatchPropsType)
}

export default connect<PropsType & DispatchPropsType, {}, _, _, _, _>(mapStateToProps, mapDispatchToProps)(ManageSocial)

export const AccountTopSection = styled.div`
  width: 100%;
  margin-top: 32px;
`

export const AccountTextA = styled.p`
  font-family: 'Good Sans Light';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: ${colors.white70};
  margin: 0;
  padding: 0 0 4px;

  ${(props: any): string => config(props).media.md`
    font-size: 18px;
    line-height: 20px;
    padding: 0 0 10px;
  `}
`
export const AccountTextB = styled(AccountTextA)`
  font-size: 16px;
  line-height: 20px;
  color: ${colors.white};
  ${(props: any): string => config(props).media.md`
    font-size: 24px;
    line-height: 28px;
  `}
`
